export const machineCost = 54500.0;
export const machineLifeBeforeRetrofit = 5;
export const dailyOperatingHours = 8;
export const daysPerMonth = 22;
export const machineRefitCost = 17500.0;
export const additionalMachineLifetime = 5;
export const cycleTime = 75;
export const cycleWeight = 12;
export const yearlyCostIncreasePercent = 8.0;
